module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/mediumTank-tiny.a87f9ef4.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/mediumTank-tiny.png
// module id = 2727
// module chunks = 11